module.exports = __webpack_public_path__ + "static/img/banner_7.97107cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_7.jpg
// module id = F3C5
// module chunks = 0